import { render } from "./DiploTabMenu.vue?vue&type=template&id=11ccdd3a&scoped=true"
import script from "./DiploTabMenu.vue?vue&type=script&lang=js"
export * from "./DiploTabMenu.vue?vue&type=script&lang=js"

import "./DiploTabMenu.vue?vue&type=style&index=0&id=11ccdd3a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ccdd3a"]])

export default __exports__